import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2593d63d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uploadbank" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, " 上传银行转账凭证 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { style: {"display":"flex","justify-content":"center"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { style: {"width":"60%"} }, {
          default: _withCtx(() => [
            (_ctx.typeStr=='status')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "充值状态",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      style: _normalizeStyle(_ctx.infoData.status == 3 ? {display:'block',marginTop:'5px'}:{})
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(_ctx.infoData.status)) + " ", 1),
                      (_ctx.infoData.status == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, ":"))
                        : _createCommentVNode("", true)
                    ], 4),
                    (_ctx.errmsg.length != 0&&_ctx.infoData.status===3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errmsg, (item) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: item.id
                            }, _toDisplayString(item.msg), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "客户编号:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.usermsg?.userCode), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "客户名称:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.usermsg?.userName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "付款方名称:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.paymentAccount), {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"100%"},
                  disabled: _ctx.infoData.status !== 3&&_ctx.typeStr == 'status',
                  value: _ctx.modelRef.paymentAccount,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.paymentAccount) = $event))
                }, null, 8, ["disabled", "value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "付款银行名称:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.paymentAccountBank), {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"100%"},
                  disabled: _ctx.infoData.status !== 3&&_ctx.typeStr == 'status',
                  value: _ctx.modelRef.paymentAccountBank,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.paymentAccountBank) = $event))
                }, null, 8, ["disabled", "value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "付款银行账号:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.paymentAccountNo), {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"100%"},
                  disabled: _ctx.infoData.status !== 3&&_ctx.typeStr == 'status',
                  value: _ctx.modelRef.paymentAccountNo,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.paymentAccountNo) = $event))
                }, null, 8, ["disabled", "value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "汇款时间:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.remittanceTime), {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  style: {"width":"100%"},
                  "show-time": "",
                  "disabled-date": _ctx.disabledDate,
                  disabled: _ctx.infoData.status !== 3&&_ctx.typeStr == 'status',
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  value: _ctx.modelRef.remittanceTime,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.remittanceTime) = $event))
                }, null, 8, ["disabled-date", "disabled", "value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "汇款金额:",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.rechargeAmount), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  style: {"width":"100%"},
                  disabled: _ctx.infoData.status !== 3&&_ctx.typeStr == 'status',
                  value: _ctx.modelRef.rechargeAmount,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.rechargeAmount) = $event)),
                  formatter: value => `${value}`.toString().match(/^\d+(?:\.\d{0,2})?/)
                }, null, 8, ["disabled", "value", "formatter"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "汇款币种",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.currency), {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  style: {"width":"100%"},
                  disabled: "",
                  value: _ctx.modelRef.currency,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.currency) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("CNY")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "银行凭证",
              labelCol: {span: 8},
              wrapperCol: {span: 14}
            }, _ctx.validateInfos.voucherFileId), {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  style: {"width":"100%"},
                  disabled: _ctx.infoData.status !== 3&&_ctx.typeStr == 'status',
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  "show-upload-list": false,
                  customRequest: _ctx.handleUpload,
                  "before-upload": _ctx.beforeUpload,
                  value: _ctx.modelRef.voucherFileId,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelRef.voucherFileId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_ctx.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "img",
                          src: _ctx.imageUrl,
                          alt: "avatar"
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_6
                        ]))
                  ]),
                  _: 1
                }, 8, ["disabled", "customRequest", "before-upload", "value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_row, { justify: "center" }, {
              default: _withCtx(() => [
                (_ctx.typeStr == 'add' || _ctx.infoData.status == 3)
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _ctx.handleSubmit,
                          disabled: _ctx.isOne
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("提交")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]),
                        _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
                          default: _withCtx(() => [
                            _createTextVNode("返回")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}